import { Injectable } from '@angular/core';
import { Colorcar } from '../models/newCarColor';
import { GradeCarDetail } from '../models/newCarDetail';
import { FukuchaDetail } from '../fukusha/model/fukushaDetail';
import { UtilService } from './util.service';
import { StaffDetail } from '../models/staffLogin';
import { gradeCar } from '../models/gradeCar';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {
  private _token: string;
  private _kyotenCd: string;
  private _staffData: StaffDetail;
  private _shatenNm = '';
  private _loginTypeKbn: string;
  private _expirationTime: number;
  private _idRemember: string;
  private _idstaffRemember: string;
  private _isGrade0 = false;
  private _gradeCarSize: number;
  private _newCarSize: number;
  public kyotenCdUpdate = new BehaviorSubject<boolean>(false);
  private _planStaffCd: string;

  currentGrade = 1;
  totalCarInPlan = 0;
  _carDetail: GradeCarDetail[] = [];
  fukuchaDetail: FukuchaDetail = {};

  isOsusume = false;
  isFukucha = false;
  _paymentMethod: number[];
  _previousPaymentMethod: number[];

  isCalcLoanComplete = new BehaviorSubject<boolean>(false);
  nLoanPlan = 0;
  nLoanCalc = 0;

  constructor(private util: UtilService) {}

  setLoanPlanCalc() {
    const isComplete = this.isCalcLoanComplete.getValue();
    if (!isComplete && this.nLoanPlan > 0) {
      this.nLoanCalc ++;
      if (this.nLoanCalc === this.nLoanPlan) {
        this.isCalcLoanComplete.next(true);
      }
    }
  }

  clearWaitLoan() {
    this.isCalcLoanComplete.next(null);
    this.nLoanCalc = 0;
    this.nLoanPlan = 0;
  }

  saveData(key: string, value) {
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  }

  getData(key: string) {
    const data = localStorage.getItem(key);
    if (data && data.startsWith('{')) {
      return JSON.parse(data);
    } else {
      return data;
    }
  }

  removeData(key: string) {
    localStorage.removeItem(key);
  }

  clearData() {
    let tmpRememeber1 = null, tmpRememeber2 = null;
    if (this.idRemember) {
      tmpRememeber1 = this._idRemember;
    }
    if (this.idstaffRemember) {
      tmpRememeber2 = this._idstaffRemember;
    }
    localStorage.clear();
    this._token = null ;
    this._kyotenCd = null ;
    this._staffData = null ;
    this._shatenNm = '';
    this._loginTypeKbn = null ;
    this._expirationTime = null ;
    this.idRemember = tmpRememeber1;
    this.idstaffRemember = tmpRememeber2;
  }

  set token(value: string){
    this.saveData('token', value);
    this._token = value;
  }

  get token(): string {
    if (this._token == null) {
      this._token = this.getData('token');
    }
    return this._token;
  }

  // get prefCd() {
  //   if (this.environmentData) {
  //     return this.environmentData.prefCd;
  //   }
  //   return null;
  // }

  set loginTypeKbn(value: string){
    this.saveData('loginTypeKbn', value);
    this._loginTypeKbn = value;
  }

  get loginTypeKbn(): string {
    this._loginTypeKbn = this.getData('loginTypeKbn');
    return this._loginTypeKbn;
  }
  set expirationTime(value: number){
    this.saveData('expirationTime', value);
    this._expirationTime = value;
  }

  get expirationTime(): number {
    return this._expirationTime;
  }

  set idRemember(value: string){
    if (value) {
      this.saveData('idRemember', value);
    } else {
      this.removeData('idRemember');
    }
    this._idRemember = value;
  }

  get idRemember(): string {
    if (this._idRemember == null) {
      this._idRemember = this.getData('idRemember');
    }
    return this._idRemember;
  }

  set idstaffRemember(value: string){
    if (value) {
      this.saveData('idstaffRemember', value);
    } else {
      this.removeData('idstaffRemember');
    }
    this._idstaffRemember = value;
  }

  get idstaffRemember(): string {
    if (this._idstaffRemember == null) {
      this._idstaffRemember = this.getData('idstaffRemember');
    }
    return this._idstaffRemember;
  }

  set staffData(value: any) {
    this.saveData('staffData', value);
    this._staffData = value;
    this.planStaffCd = null;
    if (value.shatenNm) {
      this._shatenNm = value.shatenNm;
    }
  }

  get staffData() {
    if (this._staffData == null) {
      this._staffData = this.getData('staffData');
    }
    return this._staffData;
  }

  get shatenNm() {
    if (this._shatenNm == '' && this.staffData != null && this.staffData.shatenNm) {
      this._shatenNm = this.staffData.shatenNm;
    }
    return this._shatenNm;
  }

  set shatenNm(val) {
    this._shatenNm = val;
  }

  clearStaffData() {
    this._staffData = null;
    this._loginTypeKbn = null;
    this._kyotenCd = null;
    this.kyotenCd = null;
    this.planStaffCd = null;
    this.removeData('staffData');
    this.removeData('loginTypeKbn');
    this.removeData('kyotenCd');
  }

  get staffCd() {
    if (this.staffData) {
      return this.staffData.staffCd;
    }
    return null;
  }

  set planStaffCd(value: string){
    if (value) {
      this.saveData('planStaffCd', value);
    } else {
      this.removeData('planStaffCd');
    }
    this._planStaffCd = value;
  }

  get planStaffCd() {
    this._planStaffCd = this.getData('planStaffCd');
    if (this._planStaffCd == null && this.staffData) {
      this._planStaffCd = this.staffData.staffCd;
    }
    return this._planStaffCd;
  }

  set kyotenCd(value: string) {
    if (value) {
      this.saveData('kyotenCd', value);
    } else {
      this.removeData('kyotenCd');
    }
    this._kyotenCd = value;
  }

  get kyotenCd() {
    this._kyotenCd = this.getData('kyotenCd');
    return this._kyotenCd;
  }
  get kyotenNm() {
    if (this.staffData) {
      return this.staffData.kyotenNm;
    }

    return '';
  }

  setCarGrade(grade: number) {
    this.currentGrade = grade;
  }

  get carDetail() {
    if (this._carDetail.length > 0) {
      return this._carDetail[this.currentGrade - 1];
    }
    return null;
  }

  get gradeCarSize() {
    const _gradeCarSize = this.getData('gradeCarSize');
    if (_gradeCarSize != null) {
      this._gradeCarSize = parseInt(_gradeCarSize);
    } else {
      this._gradeCarSize = 0;
    }
    return this._gradeCarSize;
  }

  set gradeCarSize(value: number) {
    this.saveData('gradeCarSize', value);
    this._gradeCarSize = value;
  }

  get newCarSize() {
    const _newCarSize = this.getData('newCarSize');
    if (_newCarSize != null) {
      this._newCarSize = parseInt(_newCarSize);
    } else {
      this._newCarSize = 0;
    }
    return this._newCarSize;
  }

  set newCarSize(value: number) {
    this.saveData('newCarSize', value);
    this._newCarSize = value;
  }

  setCarDetailSaved(carData: GradeCarDetail) {
    this._carDetail = [];
    this._carDetail.push(carData);
    this.totalCarInPlan = 1;
  }

  changeCarDetail(cardetail, color) {
    let grade = this.currentGrade;
    if (this._isGrade0) {
      grade = 0;
    }
    let index = grade > 0 ? grade - 1 : grade;
    this.removeData('carData' + grade);
    this.removeData('carColor' + grade);

    this._carDetail[index] = cardetail;
    if (cardetail) {
      this.saveData('carData' + grade, {...cardetail, selected: true});
    }
    if (color) {
      this.saveData('carColor' + grade, color);
    }
  }

  setCarDetail() {
    this._carDetail = [];
    if (this.getData('ordersNo') != null || this.getData('mitsumorino') != null) {
      this.totalCarInPlan = 1;
      this.removeData('carColor0');
      this.removeData('fukuchaDetail');
    } else if (this.getData('fukuchaDetail')) {
      this._isGrade0 = true;
      this.fukuchaDetail = this.getData('fukuchaDetail');
      this.isFukucha = true;
      this.totalCarInPlan = 1;
      const carData: GradeCarDetail = this.getData('carData0');
      this._carDetail.push(carData);
    } else {
      let gradeCarSize = this.gradeCarSize;
      if (gradeCarSize === 0) {
        gradeCarSize = 1;
      }
      this.totalCarInPlan = 0;
      for (let i = 0; i <= gradeCarSize; i++) {
        const carData: GradeCarDetail = this.getData('carData' + i);
        if (carData && (carData.selected || gradeCarSize === 1)) {
          this._carDetail.push(carData);
          this.totalCarInPlan ++;
          if (i === 0) {
            this._isGrade0 = true;
            break;
          }
        }
      }
    }
    this.initPaymentMethod();
  }

  set carColor(data) {
    let grade = this.currentGrade;
    if (this._isGrade0) {
      grade = 0;
    }
    if (data) {
      this.saveData('carColor' + grade, data);
    } else {
      this.removeData('carColor' + grade);
    }
  }

  get carColor() {
    let grade = this.currentGrade;
    if (this._isGrade0) {
      grade = 0;
    }
    return this.getData('carColor' + grade);
  }

  removeCarData() {
    this.totalCarInPlan = 0;
    this.currentGrade = 1;
    this._isGrade0 = false;
    this._carDetail = [];
    this.fukuchaDetail = {};
    this.isFukucha = false;
    this.removeData('newCarData');
    this.removeData('fukuchaDetail');
    this.removeData('fukushaColor');
    this.removeData('newCarSize');
    this.removeData('gradeCarSize');
    this.removeData('newCarColor');
    for (let i = 0; i <= 3; i++) {
      this.removeData('carData' + i);
      this.removeData('carColor' + i);
      this.removeData('newCar' + i);
    }
  }

  removeFavoriteCar() {
    this.removeCar('newCar');
  }

  removeGradeCar() {
    this.removeCar('carData');
  }

  removecarColor() {
    this.removeCar('carColor');
  }

  private removeCar(key: string) {
    for (let i = 0; i <= 3; i++) {
      this.removeData(key + i);
    }
  }

  removeOrderNoMitsumoriNo() {
    this.removeData('ordersNo');
    this.removeData('chumonValue');
    this.removeData('mitsumorino');
    this.removeData('mitsumorivalue');
    this.removeData('osusumeNo');
    this.removeData('categoryNo');
    this.removeData('backOsusume');
    this.removeData('mitsumoricd');
    this.removeBtobZaikoId();
  }

  initPaymentMethod() {
    this._paymentMethod = [0, 0 , 0];
    this._previousPaymentMethod = [0, 0 , 0];
  }

  setDefaultPaymentMethod(val) {
    this._paymentMethod = [val, val , val];
  }

  setPaymentMethod(val) {
    const index = this.currentGrade - 1;
    if (this._paymentMethod[index] < 3) {
      this._previousPaymentMethod[index] = this._paymentMethod[index];
    }
    this._paymentMethod[index] = val;
  }

  isChangeShohiyou() {
    const index = this.currentGrade - 1;
    if (this._previousPaymentMethod[index] === 1 && this._paymentMethod[index] === 2 ||
        this._paymentMethod[index] === 1 && this._previousPaymentMethod[index] === 2 ) {
      return true;
    }
    return false;
  }

  peviousPaymentMethod() {
    const index = this.currentGrade - 1;
    return this._previousPaymentMethod[index];
  }

  doTotalSumChangePayment() {
    const index = this.currentGrade - 1;
    if (this._paymentMethod[index] === 1 ||
      this._previousPaymentMethod[index] === 1 && this._paymentMethod[index] === 3) {
      return false;
    }
    return true;
  }
  getPaymentMethod() {
    return this._paymentMethod[this.currentGrade - 1];
  }

  get btobZaikoId() {
    return this.getData('btobZaikoId');
  }

  removeBtobZaikoId() {
    this.removeData('btobZaikoId');
    this.removeData('isCarchs');
  }

  get isCarchs() {
    if (this.getData('isCarchs') != null) {
      return true;
    }
    return false;
  }

  get monthlyLeaseKbn() {
    return this.getData('monthlyLeaseKbn');
  }

  get env() {
    return this.getData('env');
  }

  get stockSourceKbn() {
    return this.getData('stockSourceKbn');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/data.service.ts